const config = {
  API_URL: 'https://api.getsling.com/v1/',
  APP_URL: 'https://app.getsling.com/',
  INTEGRATIONS_PAGE_URL: 'https://app.getsling.com/settings?tab=integrations',
  AUTHORIZATION_COOKIE: 'authorization-token',
  LOGIN_PAGE_URL: 'https://login.getsling.com',
  SIGNUP_PAGE_URL: 'https://login.getsling.com/register',
  SHOPIFY_API_KEY: '166d04aa6d3ea4cf892b348fd3fdabb5',
  TOAST_SLING_CONNECT_URL: 'https://www.toasttab.com/restaurants/admin/scheduling/sling/connect',
};
export default config;
